<template>
  <div class="root">

  </div>
</template>

<script>
export default {
  name:'Footer'
}
</script>

<style lang='scss' scoped>
  .root{
    min-height: 100px;
  }
</style>